// import "./App.css";
import React from "react";
import ReactGA from "react-ga4";
import { Navigate, Route, Routes } from "react-router-dom";

import "./global.styles.css";

import AuthenticationPage from "./components/authentication/authentication-page";
import ForgottenPasswordForm from "./components/forgotten-password/forgotten-password-form";
import UnregisteredEmail from "./components/forgotten-password/unregistered-email";
import NavBar from "./components/navigation/nav-bar";
import PrayersContainer from "./components/prayers/prayers-container";
import SubmitPrayerForm from "./components/prayers/submit-prayer-form";
import SundayPrayers from "./components/sunday-prayers/sunday-prayers";

const MEASUREMENT_ID = "G-YHHKFGJEDZ";
ReactGA.initialize(MEASUREMENT_ID);

function App() {
  return (
    <>
      <Routes>
        {/* <Route path="sign-in" element={<SignInForm />} />
        <Route path="sign-up" element={<SignUpForm />} /> */}

        <Route path="sunday-prayers" element={<SundayPrayers />} />

        <Route path="/" element={<NavBar />}>
          <Route path="/" element={<PrayersContainer />} />
          <Route path="/prayers" element={<Navigate to="/" />} />
          <Route
            path="/forgotton-password"
            element={<ForgottenPasswordForm />}
          />
          <Route
            path="/sign-in/forgotton-password/uregistered-email"
            element={<UnregisteredEmail />}
          />
          <Route
            path="/sign-in/forgotton-password/uregistered-email/sign-up"
            element={<AuthenticationPage />}
          />
          <Route path="submit" element={<SubmitPrayerForm />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
